import { createSelector } from '@reduxjs/toolkit';

import { RootState } from '@redux/reducers/rootReducer';

const companiesState = (state: RootState) => state.common.companies;

const getCompaniesState = createSelector(companiesState, (state) => state);

const getCompaniesLoading = createSelector(companiesState, (state) => state.companiesLoading);

export const companiesSelectors = {
  getCompaniesState,
  getCompaniesLoading,
};
